module.exports = function() {
  return new Worker(__webpack_public_path__ + "b27acbb2a512ee20f7cb.worker.js");
};